import { media, spacing } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-grid-columns";
const baseSmallScreen = {
  display: "grid",
  [`@media (${media.queries.medium.max})`]: {
    gridGap: spacing.lg
  }
};
function composeColumns(options) {
  const { columns } = options;
  let composed = {
    ...baseSmallScreen
  };
  let className = `${classNamePrefix}`;
  let deprecatedAliases = [];
  if (columns === 2) {
    composed = {
      ...composed,
      [`@media (${media.queries.large.min})`]: {
        gridTemplateColumns: "repeat(2, 1fr)"
      }
    };
    className = `${classNamePrefix}-two`;
    deprecatedAliases.push("umd-grid");
  } else if (columns === 3) {
    composed = {
      ...composed,
      [`@media (${media.queries.tablet.min})`]: {
        gridTemplateColumns: "repeat(3, 1fr)"
      }
    };
    className = `${classNamePrefix}-three`;
    deprecatedAliases.push("umd-grid-three");
  } else if (columns === 4) {
    composed = {
      ...composed,
      [`@media (${media.queries.large.min})`]: {
        gridTemplateColumns: "repeat(2, 1fr)"
      },
      [`@media (${media.queries.desktop.min})`]: {
        gridTemplateColumns: "repeat(4, 1fr)"
      }
    };
    className = `${classNamePrefix}-four`;
    deprecatedAliases.push("umd-grid-four");
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const base = {
  two: {
    ...baseSmallScreen,
    [`@media (${media.queries.large.min})`]: {
      gridTemplateColumns: "repeat(2, 1fr)"
    }
  },
  three: {
    ...baseSmallScreen,
    [`@media (${media.queries.tablet.min})`]: {
      gridTemplateColumns: "repeat(3, 1fr)"
    }
  },
  four: {
    ...baseSmallScreen,
    [`@media (${media.queries.large.min})`]: {
      gridTemplateColumns: "repeat(2, 1fr)"
    },
    [`@media (${media.queries.desktop.min})`]: {
      gridTemplateColumns: "repeat(4, 1fr)"
    }
  }
};
const columnsTwo = composeColumns({ columns: 2 });
const columnsThree = composeColumns({ columns: 3 });
const columnsFour = composeColumns({ columns: 4 });
const stacked = objectWithClassName({
  className: `${classNamePrefix}-stacked`,
  display: "flex",
  flexDirection: "column",
  [`> *:not(:last-child)`]: {
    marginBottom: spacing.sm
  }
});
export {
  base,
  columnsFour,
  columnsThree,
  columnsTwo,
  composeColumns,
  stacked
};
//# sourceMappingURL=base.js.map
